// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD62nB0XRH7KFtbuqUP3sYJx9MTokrALuM",
    authDomain: "realestatesite-8b501.firebaseapp.com",
    projectId: "realestatesite-8b501",
    storageBucket: "realestatesite-8b501.firebasestorage.app",
    messagingSenderId: "255907237426",
    appId: "1:255907237426:web:25c0c93f6198ac1a62f62b",
    measurementId: "G-6V36SELV8X"
  },
  stripePublicKey: "pk_test_51SItBEEMwI4N33G9WblIPsiT3NWxRBIwi6RzOFWlMjGDfCXcs0utmYRE2Lmt6O8iE6Q0hplhPhDpIhovnAWfGLRE00kXViYnQN",
  stripePrivateKey: "sk_test_51SItBEEMwI4N33G91zuIr9Us9RiB83hkP82orhDrSRgqX6dnBrjcIZn3JhtY1QoIPoSKr5nJTg4FXRZdrjItykhx00OlFTd8N8",
  googleClientId:
    '255907237426-l03epgmldacqu9bn1vugl3fcdklr4aur.apps.googleusercontent.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
